export * from './liked-shared.component';